/******/ (function(modules) { // webpackBootstrap
/******/ 	// install a JSONP callback for chunk loading
/******/ 	var parentJsonpFunction = window["webpackJsonp"];
/******/ 	window["webpackJsonp"] = function webpackJsonpCallback(chunkIds, moreModules, executeModules) {
/******/ 		// add "moreModules" to the modules object,
/******/ 		// then flag all "chunkIds" as loaded and fire callback
/******/ 		var moduleId, chunkId, i = 0, resolves = [], result;
/******/ 		for(;i < chunkIds.length; i++) {
/******/ 			chunkId = chunkIds[i];
/******/ 			if(installedChunks[chunkId]) {
/******/ 				resolves.push(installedChunks[chunkId][0]);
/******/ 			}
/******/ 			installedChunks[chunkId] = 0;
/******/ 		}
/******/ 		for(moduleId in moreModules) {
/******/ 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
/******/ 				modules[moduleId] = moreModules[moduleId];
/******/ 			}
/******/ 		}
/******/ 		if(parentJsonpFunction) parentJsonpFunction(chunkIds, moreModules, executeModules);
/******/ 		while(resolves.length) {
/******/ 			resolves.shift()();
/******/ 		}
/******/
/******/ 	};
/******/
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// objects to store loaded and loading chunks
/******/ 	var installedChunks = {
/******/ 		13: 0
/******/ 	};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/ 	// This file contains only the entry chunk.
/******/ 	// The chunk loading function for additional chunks
/******/ 	__webpack_require__.e = function requireEnsure(chunkId) {
/******/ 		var installedChunkData = installedChunks[chunkId];
/******/ 		if(installedChunkData === 0) {
/******/ 			return new Promise(function(resolve) { resolve(); });
/******/ 		}
/******/
/******/ 		// a Promise means "currently loading".
/******/ 		if(installedChunkData) {
/******/ 			return installedChunkData[2];
/******/ 		}
/******/
/******/ 		// setup Promise in chunk cache
/******/ 		var promise = new Promise(function(resolve, reject) {
/******/ 			installedChunkData = installedChunks[chunkId] = [resolve, reject];
/******/ 		});
/******/ 		installedChunkData[2] = promise;
/******/
/******/ 		// start chunk loading
/******/ 		var head = document.getElementsByTagName('head')[0];
/******/ 		var script = document.createElement('script');
/******/ 		script.type = "text/javascript";
/******/ 		script.charset = 'utf-8';
/******/ 		script.async = true;
/******/ 		script.timeout = 120000;
/******/
/******/ 		if (__webpack_require__.nc) {
/******/ 			script.setAttribute("nonce", __webpack_require__.nc);
/******/ 		}
/******/ 		script.src = __webpack_require__.p + "" + ({"0":"route-add-statistic-question","1":"route-settings","2":"route-stats","3":"route-get-started","4":"route-year","5":"route-not-found","6":"route-months","7":"route-home","8":"route-highlights","9":"route-entries","10":"route-day","11":"route-add-journal-question","12":"route-about"}[chunkId]||chunkId) + ".chunk." + {"0":"d5e0c","1":"53435","2":"3984b","3":"ef9a1","4":"91370","5":"c775f","6":"f545e","7":"8729a","8":"61445","9":"32189","10":"3fbc5","11":"4c1f5","12":"cf6ae"}[chunkId] + ".js";
/******/ 		var timeout = setTimeout(onScriptComplete, 120000);
/******/ 		script.onerror = script.onload = onScriptComplete;
/******/ 		function onScriptComplete() {
/******/ 			// avoid mem leaks in IE.
/******/ 			script.onerror = script.onload = null;
/******/ 			clearTimeout(timeout);
/******/ 			var chunk = installedChunks[chunkId];
/******/ 			if(chunk !== 0) {
/******/ 				if(chunk) {
/******/ 					chunk[1](new Error('Loading chunk ' + chunkId + ' failed.'));
/******/ 				}
/******/ 				installedChunks[chunkId] = undefined;
/******/ 			}
/******/ 		};
/******/ 		head.appendChild(script);
/******/
/******/ 		return promise;
/******/ 	};
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// on error function for async loading
/******/ 	__webpack_require__.oe = function(err) { console.error(err); throw err; };
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "pwNi");
/******/ })
/************************************************************************/
/******/ ({

/***/ "/QC5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "subscribers", function() { return subscribers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getCurrentUrl", function() { return getCurrentUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "route", function() { return route; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Router", function() { return Router; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Route", function() { return Route; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Link", function() { return Link; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);


var EMPTY$1 = {};

function assign(obj, props) {
	// eslint-disable-next-line guard-for-in
	for (var i in props) {
		obj[i] = props[i];
	}
	return obj;
}

function exec(url, route, opts) {
	var reg = /(?:\?([^#]*))?(#.*)?$/,
	    c = url.match(reg),
	    matches = {},
	    ret;
	if (c && c[1]) {
		var p = c[1].split('&');
		for (var i = 0; i < p.length; i++) {
			var r = p[i].split('=');
			matches[decodeURIComponent(r[0])] = decodeURIComponent(r.slice(1).join('='));
		}
	}
	url = segmentize(url.replace(reg, ''));
	route = segmentize(route || '');
	var max = Math.max(url.length, route.length);
	for (var i$1 = 0; i$1 < max; i$1++) {
		if (route[i$1] && route[i$1].charAt(0) === ':') {
			var param = route[i$1].replace(/(^\:|[+*?]+$)/g, ''),
			    flags = (route[i$1].match(/[+*?]+$/) || EMPTY$1)[0] || '',
			    plus = ~flags.indexOf('+'),
			    star = ~flags.indexOf('*'),
			    val = url[i$1] || '';
			if (!val && !star && (flags.indexOf('?') < 0 || plus)) {
				ret = false;
				break;
			}
			matches[param] = decodeURIComponent(val);
			if (plus || star) {
				matches[param] = url.slice(i$1).map(decodeURIComponent).join('/');
				break;
			}
		} else if (route[i$1] !== url[i$1]) {
			ret = false;
			break;
		}
	}
	if (opts.default !== true && ret === false) {
		return false;
	}
	return matches;
}

function pathRankSort(a, b) {
	return a.rank < b.rank ? 1 : a.rank > b.rank ? -1 : a.index - b.index;
}

// filter out VNodes without attributes (which are unrankeable), and add `index`/`rank` properties to be used in sorting.
function prepareVNodeForRanking(vnode, index) {
	vnode.index = index;
	vnode.rank = rankChild(vnode);
	return vnode.attributes;
}

function segmentize(url) {
	return url.replace(/(^\/+|\/+$)/g, '').split('/');
}

function rankSegment(segment) {
	return segment.charAt(0) == ':' ? 1 + '*+?'.indexOf(segment.charAt(segment.length - 1)) || 4 : 5;
}

function rank(path) {
	return segmentize(path).map(rankSegment).join('');
}

function rankChild(vnode) {
	return vnode.attributes.default ? 0 : rank(vnode.attributes.path);
}

var customHistory = null;

var ROUTERS = [];

var subscribers = [];

var EMPTY = {};

function isPreactElement(node) {
	return node.__preactattr_ != null || typeof Symbol !== 'undefined' && node[Symbol.for('preactattr')] != null;
}

function setUrl(url, type) {
	if (type === void 0) type = 'push';

	if (customHistory && customHistory[type]) {
		customHistory[type](url);
	} else if (typeof history !== 'undefined' && history[type + 'State']) {
		history[type + 'State'](null, null, url);
	}
}

function getCurrentUrl() {
	var url;
	if (customHistory && customHistory.location) {
		url = customHistory.location;
	} else if (customHistory && customHistory.getCurrentLocation) {
		url = customHistory.getCurrentLocation();
	} else {
		url = typeof location !== 'undefined' ? location : EMPTY;
	}
	return "" + (url.pathname || '') + (url.search || '');
}

function route(url, replace) {
	if (replace === void 0) replace = false;

	if (typeof url !== 'string' && url.url) {
		replace = url.replace;
		url = url.url;
	}

	// only push URL into history if we can handle it
	if (canRoute(url)) {
		setUrl(url, replace ? 'replace' : 'push');
	}

	return routeTo(url);
}

/** Check if the given URL can be handled by any router instances. */
function canRoute(url) {
	for (var i = ROUTERS.length; i--;) {
		if (ROUTERS[i].canRoute(url)) {
			return true;
		}
	}
	return false;
}

/** Tell all router instances to handle the given URL.  */
function routeTo(url) {
	var didRoute = false;
	for (var i = 0; i < ROUTERS.length; i++) {
		if (ROUTERS[i].routeTo(url) === true) {
			didRoute = true;
		}
	}
	for (var i$1 = subscribers.length; i$1--;) {
		subscribers[i$1](url);
	}
	return didRoute;
}

function routeFromLink(node) {
	// only valid elements
	if (!node || !node.getAttribute) {
		return;
	}

	var href = node.getAttribute('href'),
	    target = node.getAttribute('target');

	// ignore links with targets and non-path URLs
	if (!href || !href.match(/^\//g) || target && !target.match(/^_?self$/i)) {
		return;
	}

	// attempt to route, if no match simply cede control to browser
	return route(href);
}

function handleLinkClick(e) {
	if (e.button == 0) {
		routeFromLink(e.currentTarget || e.target || this);
		return prevent(e);
	}
}

function prevent(e) {
	if (e) {
		if (e.stopImmediatePropagation) {
			e.stopImmediatePropagation();
		}
		if (e.stopPropagation) {
			e.stopPropagation();
		}
		e.preventDefault();
	}
	return false;
}

function delegateLinkHandler(e) {
	// ignore events the browser takes care of already:
	if (e.ctrlKey || e.metaKey || e.altKey || e.shiftKey || e.button !== 0) {
		return;
	}

	var t = e.target;
	do {
		if (String(t.nodeName).toUpperCase() === 'A' && t.getAttribute('href') && isPreactElement(t)) {
			if (t.hasAttribute('native')) {
				return;
			}
			// if link is handled by the router, prevent browser defaults
			if (routeFromLink(t)) {
				return prevent(e);
			}
		}
	} while (t = t.parentNode);
}

var eventListenersInitialized = false;

function initEventListeners() {
	if (eventListenersInitialized) {
		return;
	}

	if (typeof addEventListener === 'function') {
		if (!customHistory) {
			addEventListener('popstate', function () {
				routeTo(getCurrentUrl());
			});
		}
		addEventListener('click', delegateLinkHandler);
	}
	eventListenersInitialized = true;
}

var Router = function (Component$$1) {
	function Router(props) {
		Component$$1.call(this, props);
		if (props.history) {
			customHistory = props.history;
		}

		this.state = {
			url: props.url || getCurrentUrl()
		};

		initEventListeners();
	}

	if (Component$$1) Router.__proto__ = Component$$1;
	Router.prototype = Object.create(Component$$1 && Component$$1.prototype);
	Router.prototype.constructor = Router;

	Router.prototype.shouldComponentUpdate = function shouldComponentUpdate(props) {
		if (props.static !== true) {
			return true;
		}
		return props.url !== this.props.url || props.onChange !== this.props.onChange;
	};

	/** Check if the given URL can be matched against any children */
	Router.prototype.canRoute = function canRoute(url) {
		return this.getMatchingChildren(this.props.children, url, false).length > 0;
	};

	/** Re-render children with a new URL to match against. */
	Router.prototype.routeTo = function routeTo(url) {
		this._didRoute = false;
		this.setState({ url: url });

		// if we're in the middle of an update, don't synchronously re-route.
		if (this.updating) {
			return this.canRoute(url);
		}

		this.forceUpdate();
		return this._didRoute;
	};

	Router.prototype.componentWillMount = function componentWillMount() {
		ROUTERS.push(this);
		this.updating = true;
	};

	Router.prototype.componentDidMount = function componentDidMount() {
		var this$1 = this;

		if (customHistory) {
			this.unlisten = customHistory.listen(function (location) {
				this$1.routeTo("" + (location.pathname || '') + (location.search || ''));
			});
		}
		this.updating = false;
	};

	Router.prototype.componentWillUnmount = function componentWillUnmount() {
		if (typeof this.unlisten === 'function') {
			this.unlisten();
		}
		ROUTERS.splice(ROUTERS.indexOf(this), 1);
	};

	Router.prototype.componentWillUpdate = function componentWillUpdate() {
		this.updating = true;
	};

	Router.prototype.componentDidUpdate = function componentDidUpdate() {
		this.updating = false;
	};

	Router.prototype.getMatchingChildren = function getMatchingChildren(children, url, invoke) {
		return children.filter(prepareVNodeForRanking).sort(pathRankSort).map(function (vnode) {
			var matches = exec(url, vnode.attributes.path, vnode.attributes);
			if (matches) {
				if (invoke !== false) {
					var newProps = { url: url, matches: matches };
					assign(newProps, matches);
					delete newProps.ref;
					delete newProps.key;
					return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["cloneElement"])(vnode, newProps);
				}
				return vnode;
			}
		}).filter(Boolean);
	};

	Router.prototype.render = function render(ref, ref$1) {
		var children = ref.children;
		var onChange = ref.onChange;
		var url = ref$1.url;

		var active = this.getMatchingChildren(children, url, true);

		var current = active[0] || null;
		this._didRoute = !!current;

		var previous = this.previousUrl;
		if (url !== previous) {
			this.previousUrl = url;
			if (typeof onChange === 'function') {
				onChange({
					router: this,
					url: url,
					previous: previous,
					active: active,
					current: current
				});
			}
		}

		return current;
	};

	return Router;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);

var Link = function Link(props) {
	return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('a', assign({ onClick: handleLinkClick }, props));
};

var Route = function Route(props) {
	return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(props.component, props);
};

Router.subscribers = subscribers;
Router.getCurrentUrl = getCurrentUrl;
Router.route = route;
Router.Router = Router;
Router.Route = Route;
Router.Link = Link;

/* harmony default export */ __webpack_exports__["default"] = (Router);
//# sourceMappingURL=preact-router.es.js.map

/***/ }),

/***/ "2+yi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Toggle; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);



var _ref2 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('i', null);

var Toggle = function Toggle(_ref) {
  var on = _ref.on,
      onToggle = _ref.onToggle,
      _ref$label = _ref.label,
      label = _ref$label === undefined ? '' : _ref$label;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    'label',
    { 'class': 'toggle' },
    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('input', {
      type: 'checkbox',
      'class': 'screen-reader-only',
      checked: on,
      onChange: onToggle
    }),
    _ref2,
    label && Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      'span',
      null,
      label
    )
  );
};



/***/ }),

/***/ "7N8r":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (req) {
	function Async() {
		var _this = this;

		_preact.Component.call(this);

		var b = void 0,
		    old = void 0;
		this.componentWillMount = function () {
			b = _this.base = _this.nextBase || _this.__b;
			req(function (m) {
				_this.setState({ child: m.default || m });
			});
		};

		this.shouldComponentUpdate = function (_, nxt) {
			nxt = nxt.child === void 0;
			if (nxt && old === void 0 && !!b) {
				old = (0, _preact.h)(b.nodeName, { dangerouslySetInnerHTML: { __html: b.innerHTML } });
			} else {
				old = '';
			}
			return !nxt;
		};

		this.render = function (p, s) {
			return s.child ? (0, _preact.h)(s.child, p) : old;
		};
	}
	(Async.prototype = new _preact.Component()).constructor = Async;
	return Async;
};

var _preact = __webpack_require__("KM04");

/***/ }),

/***/ "8EZx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export compare */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return double; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return url; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return pad; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getOffsetToMonday; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getOffsetToYear; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return ymd; });
/* unused harmony export ordinal */
/* unused harmony export days */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return months; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return parse; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return parseToUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return format; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return shortDate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return filledArray; });
/* unused harmony export fudgeDates */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return sortDates; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_preact_router_match__ = __webpack_require__("sw5u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_preact_router_match___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_preact_router_match__);



/**
 * Returns  0 if dates are equal
 * Returns  1 if a > b
 * Returns -1 if b > a
 */
var compare = function compare(a, b) {
  a = new Date(a);
  b = new Date(b);

  if (a > b) {
    return 1;
  } else if (b > a) {
    return -1;
  }

  return 0;
};

var double = function double(n) {
  return n < 9 ? '0' + n : n;
};

var url = function url() {
  var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Date();
  var suffix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return '/' + date.getFullYear() + '/' + double(date.getMonth() + 1) + '/' + double(date.getDate()) + '/' + (suffix ? suffix + '/' : '');
};

var pad = function pad(n) {
  return (n < 10 ? '0' : '') + n;
};

var getOffsetToMonday = function getOffsetToMonday() {
  var d = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Date();

  var day = d.getDay();
  return day - (!day ? -6 : 1);
};

/**
 * @link https://www.devcurry.com/2011/08/javascript-find-day-of-year.html
 */
var getOffsetToYear = function getOffsetToYear() {
  var timestmp = new Date().setFullYear(new Date().getFullYear(), 0, 1);
  var yearFirstDay = Math.floor(timestmp / 86400000);
  var today = Math.ceil(new Date().getTime() / 86400000);
  return today - yearFirstDay;
};

var ymd = function ymd() {
  var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Date();

  var y = date.getFullYear();
  var m = pad(date.getMonth() + 1);
  var d = pad(date.getDate());

  return '' + y + m + d; // Example: 20190103
};

var ordinal = function ordinal(n) {
  switch (n) {
    case 1:
    case 21:
    case 31:
      return n + 'st';
    case 2:
    case 22:
      return n + 'nd';
    case 3:
    case 23:
      return n + 'rd';
    default:
      return n + 'th';
  }
};

var days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

var parse = function parse(date) {
  var year = Number(date.substring(0, 4));
  var month = Number(date.substring(4, 6)) - 1;
  var day = Number(date.substring(6, 8));
  return new Date(year, month, day);
};

var parseToUrl = function parseToUrl(date) {
  var suffix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  return url(parse(date), suffix);
};

var format = function format(date) {
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    'span',
    null,
    days[date.getDay()],
    ' ',
    ordinal(date.getDate()),
    ' ',
    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      __WEBPACK_IMPORTED_MODULE_1_preact_router_match__["Link"],
      { href: '/' + date.getFullYear() + '/' + pad(date.getMonth() + 1) },
      months[date.getMonth()]
    ),
    ' ',
    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      __WEBPACK_IMPORTED_MODULE_1_preact_router_match__["Link"],
      { href: '/' + date.getFullYear() },
      date.getFullYear()
    )
  );
};

var shortDate = function shortDate(date) {
  var dayName = days[date.getDay()].substring(0, 3);
  return dayName + ' ' + ordinal(date.getDate()) + ' ' + months[date.getMonth()];
};

var filledArray = function filledArray() {
  var v = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var count = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 12;
  return new Array(count).fill(v);
};

/**
 * I painted myself into a corner with bad dates :(
 * This little beaut breaks the awful date string apart and puts it back
 * together again with a bit of string hackery. Sorry to anyone who sees this.
 *
 * @param  date   string  201801
 * @return object { year, month, day }
 */
var fudgeDates = function fudgeDates(date) {
  var monthAndDay = date.substring(4);
  var length = monthAndDay.length;
  var middle = void 0;

  if (length === 4 || length === 2) {
    middle = length / 2;
  } else {
    if (monthAndDay.indexOf('10') === 0 || monthAndDay.indexOf('11') === 0) {
      middle = 2;
    } else {
      middle = 1;
    }
  }

  var year = Number(date.substring(0, 4));
  var month = Number(monthAndDay.substring(0, middle));
  var day = Number(monthAndDay.substring(middle));

  return { year: year, month: month, day: day };
};

var sortDates = function sortDates(a, b) {
  if (a < b) {
    return -1;
  } else if (a === b) {
    return 0;
  } else {
    return 1;
  }
};

/***/ }),

/***/ "CZP8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AddQuestion; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);



var _ref2 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('input', {
  id: 'add-question',
  type: 'text',
  dir: 'auto',
  name: 'question',
  required: true,
  placeholder: 'e.g. What are you grateful for?'
});

var _ref3 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
  'button',
  { type: 'submit' },
  Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    'svg',
    { width: '14', height: '14', xmlns: 'http://www.w3.org/2000/svg' },
    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      'title',
      null,
      'Add prompt'
    ),
    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('path', {
      d: 'M13.13 6.13H7.87V.88C7.88.34 7.54 0 7 0s-.88.35-.88.88v5.25H.88C.35 6.13 0 6.46 0 7s.35.88.88.88h5.25v5.25c0 .52.34.87.87.87s.88-.35.88-.88V7.88h5.25c.52 0 .87-.35.87-.88s-.35-.88-.88-.88z',
      fill: 'currentColor',
      'fill-rule': 'nonzero'
    })
  )
);

var _ref4 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
  'button',
  { type: 'submit', 'class': 'button' },
  'Add prompt'
);

var AddQuestion = function AddQuestion(_ref) {
  var addQuestion = _ref.addQuestion,
      _ref$label = _ref.label,
      label = _ref$label === undefined ? 'Write your own prompt' : _ref$label,
      _ref$plus = _ref.plus,
      plus = _ref$plus === undefined ? false : _ref$plus;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    'form',
    { onSubmit: addQuestion, 'class': plus ? 'add-question' : 'pt20' },
    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      'div',
      { 'class': plus ? '' : 'mb20' },
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        'label',
        { 'for': 'add-question' },
        label
      ),
      _ref2
    ),
    plus ? _ref3 : _ref4
  );
};



/***/ }),

/***/ "JkW7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ../node_modules/preact/dist/preact.min.js
var preact_min = __webpack_require__("KM04");
var preact_min_default = /*#__PURE__*/__webpack_require__.n(preact_min);

// EXTERNAL MODULE: ./style/index.css
var style = __webpack_require__("rq4c");
var style_default = /*#__PURE__*/__webpack_require__.n(style);

// EXTERNAL MODULE: ../node_modules/preact-router/dist/preact-router.es.js
var preact_router_es = __webpack_require__("/QC5");

// EXTERNAL MODULE: ../node_modules/idb/build/idb.js
var idb = __webpack_require__("iYir");
var idb_default = /*#__PURE__*/__webpack_require__.n(idb);

// CONCATENATED MODULE: ./utils/beacon.js
function shouldBlockBeacon() {
  return window.navigator.doNotTrack === '1' || window.navigator.msDoNotTrack === '1' || window.doNotTrack === '1' || window.msDoNotTrack === '1';
}

var sendBeacon = function sendBeacon(type) {
  if (!navigator.sendBeacon || !"" || shouldBlockBeacon()) {
    return;
  }

  navigator.sendBeacon("", JSON.stringify({
    type: type,
    url: window.location.pathname + (window.location.search || '')
  }));
};
// EXTERNAL MODULE: ../node_modules/preact-router/match.js
var match = __webpack_require__("sw5u");
var match_default = /*#__PURE__*/__webpack_require__.n(match);

// EXTERNAL MODULE: ./utils/date.js
var date = __webpack_require__("8EZx");

// CONCATENATED MODULE: ./components/Header/index.js





var today = Object(date["l" /* url */])();

var Header__ref2 = Object(preact_min["h"])('img', { src: '/assets/images/ww-logo-strap-white.png', 'class': 'header-logo', alt: '' });

var _ref3 = Object(preact_min["h"])('img', { src: '/assets/images/write4.png', 'class': 'header-icon', alt: '', title: 'Write' });

var _ref4 = Object(preact_min["h"])(
  'svg',
  {
    version: '1.1',
    xmlns: 'http://www.w3.org/2000/svg',
    width: '25',
    height: '25',
    viewBox: '0 0 26 26'
  },
  Object(preact_min["h"])(
    'title',
    null,
    'Review'
  ),
  Object(preact_min["h"])('path', {
    d: 'M19 3h-2v-1c0-0.6-0.4-1-1-1s-1 0.4-1 1v1h-6v-1c0-0.6-0.4-1-1-1s-1 0.4-1 1v1h-2c-1.7 0-3 1.3-3 3v14c0 1.7 1.3 3 3 3h14c1.7 0 3-1.3 3-3v-14c0-1.7-1.3-3-3-3zM5 5h2v1c0 0.6 0.4 1 1 1s1-0.4 1-1v-1h6v1c0 0.6 0.4 1 1 1s1-0.4 1-1v-1h2c0.6 0 1 0.4 1 1v3h-16v-3c0-0.6 0.4-1 1-1zM19 21h-14c-0.6 0-1-0.4-1-1v-9h16v9c0 0.6-0.4 1-1 1z',
    fill: 'currentColor'
  })
);

var _ref5 = Object(preact_min["h"])('img', { src: '/assets/images/barchart4.png', 'class': 'header-icon', alt: '', title: 'Activity' });

var _ref6 = Object(preact_min["h"])(
  'svg',
  {
    version: '1.1',
    xmlns: 'http://www.w3.org/2000/svg',
    width: '25',
    height: '25',
    viewBox: '0 0 26 26'
  },
  Object(preact_min["h"])(
    'title',
    null,
    'Settings'
  ),
  Object(preact_min["h"])('path', {
    d: 'M12 8c-2.2 0-4 1.8-4 4s1.8 4 4 4c2.2 0 4-1.8 4-4s-1.8-4-4-4zM12 14c-1.1 0-2-0.9-2-2s0.9-2 2-2c1.1 0 2 0.9 2 2s-0.9 2-2 2z',
    fill: 'currentColor'
  }),
  Object(preact_min["h"])('path', {
    d: 'M20.3 15.4c0.1-0.2 0.3-0.4 0.7-0.4 1.7 0 3-1.3 3-3s-1.3-3-3-3h-0.2c-0.2 0-0.4-0.1-0.5-0.3 0-0.1 0-0.1-0.1-0.2-0.1-0.2-0.1-0.5 0.2-0.8 1.2-1.2 1.2-3.1 0-4.2v0c0 0 0 0 0 0-0.6-0.6-1.3-0.9-2.1-0.9 0 0 0 0 0 0-0.8 0-1.6 0.3-2.2 0.9-0.2 0.2-0.5 0.2-0.7 0.1-0.2 0-0.4-0.3-0.4-0.6 0-1.7-1.3-3-3-3s-3 1.3-3 3v0.2c0 0.2-0.1 0.4-0.3 0.5-0.1 0-0.1 0-0.2 0.1-0.2 0.1-0.5 0-0.8-0.2-1.2-1.2-3.1-1.2-4.2 0-1.2 1.2-1.2 3.1 0.1 4.3 0.2 0.2 0.2 0.5 0.1 0.8-0.1 0.2-0.4 0.4-0.7 0.4-1.7 0-3 1.3-3 3s1.3 3 3 3h0.2c0.3 0 0.5 0.2 0.6 0.4s0.1 0.5-0.2 0.8c-0.6 0.6-0.9 1.3-0.9 2.1s0.3 1.5 0.9 2.1c0 0 0 0 0 0 1.2 1.2 3.1 1.2 4.3-0.1 0.2-0.2 0.5-0.2 0.8-0.1s0.4 0.3 0.4 0.7c0 1.7 1.3 3 3 3s3-1.3 3-3v-0.2c0-0.3 0.2-0.5 0.4-0.6s0.5-0.1 0.8 0.2c1.2 1.2 3.1 1.2 4.2 0 1.2-1.2 1.2-3.1-0.1-4.3-0.1-0.2-0.2-0.5-0.1-0.7 0 0 0 0 0 0zM18.5 14.6c-0.4 1-0.2 2.1 0.6 3 0.2 0.2 0.3 0.4 0.3 0.7s-0.1 0.5-0.3 0.7c-0.2 0.2-0.4 0.3-0.7 0.3 0 0 0 0 0 0-0.3 0-0.5-0.1-0.8-0.4-0.8-0.8-1.9-1-2.9-0.5-1 0.4-1.6 1.4-1.6 2.4v0.2c0 0.6-0.4 1-1 1s-1-0.4-1-1c0 0 0-0.1 0-0.1 0-1.1-0.7-2-1.7-2.4-0.3-0.2-0.7-0.2-1.1-0.2-0.7 0-1.4 0.3-1.9 0.8-0.4 0.4-1 0.4-1.4 0 0 0 0 0 0 0v0c-0.2-0.2-0.3-0.4-0.3-0.7s0.1-0.5 0.4-0.8c0.8-0.8 1-1.9 0.5-2.9-0.4-1-1.4-1.6-2.4-1.6h-0.2c-0.6 0-1-0.4-1-1s0.4-1 1-1c0 0 0.1 0 0.1 0 1.1 0 2-0.7 2.4-1.7s0.2-2.1-0.6-3c-0.4-0.4-0.4-1 0-1.4s1-0.4 1.5 0.1c0.7 0.7 1.8 0.9 2.7 0.6 0.1 0 0.2 0 0.3-0.1 1-0.4 1.6-1.4 1.6-2.4v-0.2c0-0.6 0.4-1 1-1s1 0.4 1 1.1c0 1.1 0.6 2 1.6 2.4s2.1 0.2 3-0.6c0.2-0.2 0.4-0.3 0.7-0.3v0c0.3 0 0.5 0.1 0.7 0.3 0 0 0 0 0 0 0.4 0.4 0.4 1-0.1 1.5-0.7 0.7-0.9 1.8-0.6 2.7 0 0.1 0 0.2 0.1 0.3 0.4 1 1.4 1.6 2.4 1.6h0.2c0.6 0 1 0.4 1 1s-0.4 1-1.1 1c-1 0-2 0.6-2.4 1.6z',
    fill: 'currentColor'
  })
);

var Header_Header = function Header(_ref) {
  var _ref$onboarded = _ref.onboarded,
      onboarded = _ref$onboarded === undefined ? false : _ref$onboarded;
  return Object(preact_min["h"])(
    'header',
    { 'class': 'header' },
    Object(preact_min["h"])(
      'div',
      { 'class': 'wrap' },
      Object(preact_min["h"])(
        match["Link"],
        { href: '/' },
        Header__ref2
      ),
      onboarded && Object(preact_min["h"])(
        match["Link"],
        { href: today },
        _ref3
      ),
      onboarded && Object(preact_min["h"])(
        match["Link"],
        { href: '/' + new Date().getFullYear() },
        _ref4
      ),
      onboarded && Object(preact_min["h"])(
        match["Link"],
        { href: '/stats/' },
        _ref5
      ),
      onboarded && Object(preact_min["h"])(
        match["Link"],
        { href: '/settings/' },
        _ref6
      )
    )
  );
};

/* harmony default export */ var components_Header = (Header_Header);
// EXTERNAL MODULE: ../node_modules/preact-cli/lib/components/async.js
var components_async = __webpack_require__("7N8r");
var async_default = /*#__PURE__*/__webpack_require__.n(components_async);

// CONCATENATED MODULE: ./routes/home/index.js

		

		function load(cb) {
			__webpack_require__.e/* require.ensure */(7).then((function (require) {
				cb( __webpack_require__("iOg+") );
			}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
		}

		/* harmony default export */ var home = (async_default()(load));
	
// CONCATENATED MODULE: ./routes/day/index.js

		

		function day_load(cb) {
			__webpack_require__.e/* require.ensure */(10).then((function (require) {
				cb( __webpack_require__("Hy3g") );
			}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
		}

		/* harmony default export */ var day = (async_default()(day_load));
	
// CONCATENATED MODULE: ./routes/months/index.js

		

		function months_load(cb) {
			__webpack_require__.e/* require.ensure */(6).then((function (require) {
				cb( __webpack_require__("gczx") );
			}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
		}

		/* harmony default export */ var months = (async_default()(months_load));
	
// CONCATENATED MODULE: ./routes/year/index.js

		

		function year_load(cb) {
			__webpack_require__.e/* require.ensure */(4).then((function (require) {
				cb( __webpack_require__("PXh1") );
			}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
		}

		/* harmony default export */ var year = (async_default()(year_load));
	
// CONCATENATED MODULE: ./routes/settings/index.js

		

		function settings_load(cb) {
			__webpack_require__.e/* require.ensure */(1).then((function (require) {
				cb( __webpack_require__("i8EF") );
			}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
		}

		/* harmony default export */ var routes_settings = (async_default()(settings_load));
	
// CONCATENATED MODULE: ./routes/stats/index.js

		

		function stats_load(cb) {
			__webpack_require__.e/* require.ensure */(2).then((function (require) {
				cb( __webpack_require__("OHvr") );
			}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
		}

		/* harmony default export */ var stats = (async_default()(stats_load));
	
// CONCATENATED MODULE: ./routes/get-started/index.js

		

		function get_started_load(cb) {
			__webpack_require__.e/* require.ensure */(3).then((function (require) {
				cb( __webpack_require__("ZUAp") );
			}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
		}

		/* harmony default export */ var get_started = (async_default()(get_started_load));
	
// CONCATENATED MODULE: ./routes/highlights/index.js

		

		function highlights_load(cb) {
			__webpack_require__.e/* require.ensure */(8).then((function (require) {
				cb( __webpack_require__("jsGl") );
			}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
		}

		/* harmony default export */ var highlights = (async_default()(highlights_load));
	
// CONCATENATED MODULE: ./routes/entries/index.js

		

		function entries_load(cb) {
			__webpack_require__.e/* require.ensure */(9).then((function (require) {
				cb( __webpack_require__("VCKE") );
			}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
		}

		/* harmony default export */ var entries = (async_default()(entries_load));
	
// CONCATENATED MODULE: ./routes/about/index.js

		

		function about_load(cb) {
			__webpack_require__.e/* require.ensure */(12).then((function (require) {
				cb( __webpack_require__("LOGg") );
			}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
		}

		/* harmony default export */ var about = (async_default()(about_load));
	
// CONCATENATED MODULE: ./routes/not-found/index.js

		

		function not_found_load(cb) {
			__webpack_require__.e/* require.ensure */(5).then((function (require) {
				cb( __webpack_require__("LOzz") );
			}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
		}

		/* harmony default export */ var not_found = (async_default()(not_found_load));
	
// CONCATENATED MODULE: ./routes/add-journal-question/index.js

		

		function add_journal_question_load(cb) {
			__webpack_require__.e/* require.ensure */(11).then((function (require) {
				cb( __webpack_require__("Xo98") );
			}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
		}

		/* harmony default export */ var add_journal_question = (async_default()(add_journal_question_load));
	
// CONCATENATED MODULE: ./routes/add-statistic-question/index.js

		

		function add_statistic_question_load(cb) {
			__webpack_require__.e/* require.ensure */(0).then((function (require) {
				cb( __webpack_require__("ZMXW") );
			}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
		}

		/* harmony default export */ var add_statistic_question = (async_default()(add_statistic_question_load));
	
// EXTERNAL MODULE: ./utils/theme.js
var utils_theme = __webpack_require__("wGNj");

// EXTERNAL MODULE: ../node_modules/unistore/preact.js
var preact = __webpack_require__("o6ac");
var preact_default = /*#__PURE__*/__webpack_require__.n(preact);

// EXTERNAL MODULE: ./store/actions.js + 1 modules
var actions = __webpack_require__("QlVn");

// CONCATENATED MODULE: ./components/DBError/index.js



var DBError__ref2 = Object(preact_min["h"])(
  "p",
  null,
  "Sorry! There was a setting up the local data store."
);

var DBError__ref3 = Object(preact_min["h"])(
  "p",
  null,
  "This can happen in Firefox, particularly in private windows."
);

var DBError_DBError = function DBError(_ref) {
  var _ref$toggle = _ref.toggle,
      toggle = _ref$toggle === undefined ? function () {
    return null;
  } : _ref$toggle;
  return Object(preact_min["h"])(
    "aside",
    { "class": "db-error" },
    Object(preact_min["h"])(
      "div",
      { "class": "db-error__content" },
      DBError__ref2,
      DBError__ref3,
      Object(preact_min["h"])(
        "button",
        { onClick: function onClick() {
            return location.reload();
          }, "class": "button" },
        "Try refreshing"
      )
    ),
    Object(preact_min["h"])("button", {
      type: "button",
      onClick: toggle,
      "aria-label": "Dismiss",
      "class": "db-error__dismiss"
    })
  );
};


// CONCATENATED MODULE: ./components/app.js


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

























var isOnboarded = function isOnboarded() {
  return !!localStorage.getItem('journalbook_onboarded');
};

var app__ref3 = Object(preact_min["h"])(home, { path: '/' });

var app__ref4 = Object(preact_min["h"])(get_started, { path: '/get-started/' });

var app__ref5 = Object(preact_min["h"])(routes_settings, { path: '/settings/' });

var app__ref6 = Object(preact_min["h"])(stats, { path: '/stats/' });

var _ref7 = Object(preact_min["h"])(about, { path: '/about/' });

var _ref8 = Object(preact_min["h"])(add_journal_question, { path: '/add-journal-question/' });

var _ref9 = Object(preact_min["h"])(add_statistic_question, { path: '/add-statistic-question/' });

var _ref10 = Object(preact_min["h"])(highlights, { path: '/highlights/' });

var _ref11 = Object(preact_min["h"])(entries, { path: '/entries/:questionId' });

var _ref12 = Object(preact_min["h"])(day, { path: '/:year/:month/:day/:set?' });

var _ref13 = Object(preact_min["h"])(months, { path: '/:year/:month' });

var _ref14 = Object(preact_min["h"])(year, { path: '/:year' });

var _ref15 = Object(preact_min["h"])(not_found, { 'default': true });

var app_App = function (_Component) {
  _inherits(App, _Component);

  function App() {
    var _temp, _this, _ret;

    _classCallCheck(this, App);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
      onboarded: isOnboarded(),
      dbError: false
    }, _this.handleRoute = function () {
      sendBeacon('hit');

      if (_this.state.onboarded !== isOnboarded()) {
        _this.setState({
          onboarded: isOnboarded()
        });
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  App.prototype.componentDidMount = function componentDidMount() {
    return new Promise(function ($return, $error) {
      var _this2, version, dbPromise;

      _this2 = this;
      var $Try_1_Post = function () {
        try {
          return $return();
        } catch ($boundEx) {
          return $error($boundEx);
        }
      };var $Try_1_Catch = function (e) {
        try {
          this.setState({ dbError: true });
          return $Try_1_Post();
        } catch ($boundEx) {
          return $error($boundEx);
        }
      }.bind(this);
      try {
        version = 5;
        dbPromise = Object(idb["openDb"])('entries-store', version, function (udb) {
          switch (udb.oldVersion) {
            case 0:
              udb.createObjectStore('questions');
            case 1:
              udb.createObjectStore('entries');
            case 2:
              udb.createObjectStore('highlights');
            case 3:
              udb.createObjectStore('settings', {
                theme: localStorage.getItem('journalbook_theme') || '',
                animation: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'off' : ''
              });
            case 4:
              udb.createObjectStore('trackingQuestions');
              udb.createObjectStore('trackingEntries');

          }
        });

        return Promise.resolve(dbPromise).then(function ($await_2) {
          try {
            return Promise.resolve(this.props.boot(dbPromise)).then(function ($await_3) {
              try {

                if (this.props.settings) {
                  if (this.props.settings.theme === '') {
                    window.matchMedia('(prefers-color-scheme: dark)').addListener(function (e) {
                      _this2.setState({ theme: e.matches ? 'dark' : '' });
                    });
                  }

                  if (this.props.settings.theme === '') {
                    window.matchMedia('(prefers-reduced-motion: reduce)').addListener(function (e) {
                      _this2.setState({ animation: e.matches ? 'off' : '' });
                    });
                  }
                }
                return $Try_1_Post();
              } catch ($boundEx) {
                return $Try_1_Catch($boundEx);
              }
            }.bind(this), $Try_1_Catch);
          } catch ($boundEx) {
            return $Try_1_Catch($boundEx);
          }
        }.bind(this), $Try_1_Catch);
      } catch (e) {
        $Try_1_Catch(e)
      }
    }.bind(this));
  };

  App.prototype.render = function render(_ref, _ref2) {
    var _this3 = this;

    var _ref$settings = _ref.settings,
        settings = _ref$settings === undefined ? {} : _ref$settings,
        db = _ref.db;
    var onboarded = _ref2.onboarded,
        dbError = _ref2.dbError;

    var theme = settings.theme || Object(utils_theme["a" /* getDefaultTheme */])(settings);
    var animation = settings.animation || Object(utils_theme["b" /* prefersAnimation */])(settings);

    return Object(preact_min["h"])(
      'div',
      {
        id: 'app',
        'data-theme': theme,
        'data-reduce-motion': animation === 'off' ? 'true' : 'false'
      },
      Object(preact_min["h"])(components_Header, { onboarded: onboarded }),
      db && Object(preact_min["h"])(
        preact_router_es["Router"],
        { onChange: this.handleRoute },
        app__ref3,
        app__ref4,
        app__ref5,
        app__ref6,
        _ref7,
        _ref8,
        _ref9,
        _ref10,
        _ref11,
        _ref12,
        _ref13,
        _ref14,
        _ref15
      ),
      dbError && Object(preact_min["h"])(DBError_DBError, {
        toggle: function toggle() {
          return _this3.setState({
            dbError: false
          });
        }
      })
    );
  };

  return App;
}(preact_min["Component"]);

/* harmony default export */ var app = (Object(preact["connect"])('settings, db', actions["a" /* actions */])(app_App));
// CONCATENATED MODULE: ../node_modules/unistore/dist/unistore.es.js
function n(n, t) {
  for (var r in t) {
    n[r] = t[r];
  }return n;
}/* harmony default export */ var unistore_es = (function (t) {
  var r = [];function u(n) {
    for (var t = [], u = 0; u < r.length; u++) {
      r[u] === n ? n = null : t.push(r[u]);
    }r = t;
  }function e(u, e, f) {
    t = e ? u : n(n({}, t), u);for (var i = r, o = 0; o < i.length; o++) {
      i[o](t, f);
    }
  }return t = t || {}, { action: function action(n) {
      function r(t) {
        e(t, !1, n);
      }return function () {
        for (var u = arguments, e = [t], f = 0; f < arguments.length; f++) {
          e.push(u[f]);
        }var i = n.apply(this, e);if (null != i) return i.then ? i.then(r) : r(i);
      };
    }, setState: e, subscribe: function subscribe(n) {
      return r.push(n), function () {
        u(n);
      };
    }, unsubscribe: u, getState: function getState() {
      return t;
    } };
});
//# sourceMappingURL=unistore.es.js.map
// CONCATENATED MODULE: ./store/index.js


var store = {
  settings: {
    theme: '',
    animation: ''
  },
  db: null
};

/* harmony default export */ var store_0 = (unistore_es(store));
// CONCATENATED MODULE: ./index.js






var index__ref = Object(preact_min["h"])(
  preact["Provider"],
  { store: store_0 },
  Object(preact_min["h"])(app, null)
);

/* harmony default export */ var index = __webpack_exports__["default"] = (function () {
  return index__ref;
});

/***/ }),

/***/ "KGMw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = slugify;
var uuidv4 = __webpack_require__("hYHi");
/* eslint-disable */
function slugify(text) {
  return uuidv4();
}

/***/ }),

/***/ "KM04":
/***/ (function(module, exports, __webpack_require__) {

!function () {
  "use strict";
  function e(e, t) {
    var n,
        o,
        r,
        i,
        l = W;for (i = arguments.length; i-- > 2;) {
      P.push(arguments[i]);
    }t && null != t.children && (P.length || P.push(t.children), delete t.children);while (P.length) {
      if ((o = P.pop()) && void 0 !== o.pop) for (i = o.length; i--;) {
        P.push(o[i]);
      } else "boolean" == typeof o && (o = null), (r = "function" != typeof e) && (null == o ? o = "" : "number" == typeof o ? o += "" : "string" != typeof o && (r = !1)), r && n ? l[l.length - 1] += o : l === W ? l = [o] : l.push(o), n = r;
    }var a = new T();return a.nodeName = e, a.children = l, a.attributes = null == t ? void 0 : t, a.key = null == t ? void 0 : t.key, void 0 !== M.vnode && M.vnode(a), a;
  }function t(e, t) {
    for (var n in t) {
      e[n] = t[n];
    }return e;
  }function n(e, t) {
    e && ("function" == typeof e ? e(t) : e.current = t);
  }function o(n, o) {
    return e(n.nodeName, t(t({}, n.attributes), o), arguments.length > 2 ? [].slice.call(arguments, 2) : n.children);
  }function r(e) {
    !e.__d && (e.__d = !0) && 1 == V.push(e) && (M.debounceRendering || D)(i);
  }function i() {
    var e;while (e = V.pop()) {
      e.__d && x(e);
    }
  }function l(e, t, n) {
    return "string" == typeof t || "number" == typeof t ? void 0 !== e.splitText : "string" == typeof t.nodeName ? !e._componentConstructor && a(e, t.nodeName) : n || e._componentConstructor === t.nodeName;
  }function a(e, t) {
    return e.__n === t || e.nodeName.toLowerCase() === t.toLowerCase();
  }function u(e) {
    var n = t({}, e.attributes);n.children = e.children;var o = e.nodeName.defaultProps;if (void 0 !== o) for (var r in o) {
      void 0 === n[r] && (n[r] = o[r]);
    }return n;
  }function c(e, t) {
    var n = t ? document.createElementNS("http://www.w3.org/2000/svg", e) : document.createElement(e);return n.__n = e, n;
  }function p(e) {
    var t = e.parentNode;t && t.removeChild(e);
  }function s(e, t, o, r, i) {
    if ("className" === t && (t = "class"), "key" === t) ;else if ("ref" === t) n(o, null), n(r, e);else if ("class" !== t || i) {
      if ("style" === t) {
        if (r && "string" != typeof r && "string" != typeof o || (e.style.cssText = r || ""), r && "object" == typeof r) {
          if ("string" != typeof o) for (var l in o) {
            l in r || (e.style[l] = "");
          }for (var l in r) {
            e.style[l] = "number" == typeof r[l] && !1 === E.test(l) ? r[l] + "px" : r[l];
          }
        }
      } else if ("dangerouslySetInnerHTML" === t) r && (e.innerHTML = r.__html || "");else if ("o" == t[0] && "n" == t[1]) {
        var a = t !== (t = t.replace(/Capture$/, ""));t = t.toLowerCase().substring(2), r ? o || e.addEventListener(t, _, a) : e.removeEventListener(t, _, a), (e.__l || (e.__l = {}))[t] = r;
      } else if ("list" !== t && "type" !== t && !i && t in e) {
        try {
          e[t] = null == r ? "" : r;
        } catch (e) {}null != r && !1 !== r || "spellcheck" == t || e.removeAttribute(t);
      } else {
        var u = i && t !== (t = t.replace(/^xlink:?/, ""));null == r || !1 === r ? u ? e.removeAttributeNS("http://www.w3.org/1999/xlink", t.toLowerCase()) : e.removeAttribute(t) : "function" != typeof r && (u ? e.setAttributeNS("http://www.w3.org/1999/xlink", t.toLowerCase(), r) : e.setAttribute(t, r));
      }
    } else e.className = r || "";
  }function _(e) {
    return this.__l[e.type](M.event && M.event(e) || e);
  }function f() {
    var e;while (e = A.shift()) {
      M.afterMount && M.afterMount(e), e.componentDidMount && e.componentDidMount();
    }
  }function d(e, t, n, o, r, i) {
    H++ || (R = null != r && void 0 !== r.ownerSVGElement, B = null != e && !("__preactattr_" in e));var l = h(e, t, n, o, i);return r && l.parentNode !== r && r.appendChild(l), --H || (B = !1, i || f()), l;
  }function h(e, t, n, o, r) {
    var i = e,
        l = R;if (null != t && "boolean" != typeof t || (t = ""), "string" == typeof t || "number" == typeof t) return e && void 0 !== e.splitText && e.parentNode && (!e._component || r) ? e.nodeValue != t && (e.nodeValue = t) : (i = document.createTextNode(t), e && (e.parentNode && e.parentNode.replaceChild(i, e), v(e, !0))), i.__preactattr_ = !0, i;var u = t.nodeName;if ("function" == typeof u) return N(e, t, n, o);if (R = "svg" === u || "foreignObject" !== u && R, u += "", (!e || !a(e, u)) && (i = c(u, R), e)) {
      while (e.firstChild) {
        i.appendChild(e.firstChild);
      }e.parentNode && e.parentNode.replaceChild(i, e), v(e, !0);
    }var p = i.firstChild,
        s = i.__preactattr_,
        _ = t.children;if (null == s) {
      s = i.__preactattr_ = {};for (var f = i.attributes, d = f.length; d--;) {
        s[f[d].name] = f[d].value;
      }
    }return !B && _ && 1 === _.length && "string" == typeof _[0] && null != p && void 0 !== p.splitText && null == p.nextSibling ? p.nodeValue != _[0] && (p.nodeValue = _[0]) : (_ && _.length || null != p) && m(i, _, n, o, B || null != s.dangerouslySetInnerHTML), y(i, t.attributes, s), R = l, i;
  }function m(e, t, n, o, r) {
    var i,
        a,
        u,
        c,
        s,
        _ = e.childNodes,
        f = [],
        d = {},
        m = 0,
        b = 0,
        y = _.length,
        g = 0,
        w = t ? t.length : 0;if (0 !== y) for (var C = 0; C < y; C++) {
      var x = _[C],
          N = x.__preactattr_,
          k = w && N ? x._component ? x._component.__k : N.key : null;null != k ? (m++, d[k] = x) : (N || (void 0 !== x.splitText ? !r || x.nodeValue.trim() : r)) && (f[g++] = x);
    }if (0 !== w) for (var C = 0; C < w; C++) {
      c = t[C], s = null;var k = c.key;if (null != k) m && void 0 !== d[k] && (s = d[k], d[k] = void 0, m--);else if (b < g) for (i = b; i < g; i++) {
        if (void 0 !== f[i] && l(a = f[i], c, r)) {
          s = a, f[i] = void 0, i === g - 1 && g--, i === b && b++;break;
        }
      }s = h(s, c, n, o), u = _[C], s && s !== e && s !== u && (null == u ? e.appendChild(s) : s === u.nextSibling ? p(u) : e.insertBefore(s, u));
    }if (m) for (var C in d) {
      void 0 !== d[C] && v(d[C], !1);
    }while (b <= g) {
      void 0 !== (s = f[g--]) && v(s, !1);
    }
  }function v(e, t) {
    var o = e._component;o ? k(o) : (null != e.__preactattr_ && n(e.__preactattr_.ref, null), !1 !== t && null != e.__preactattr_ || p(e), b(e));
  }function b(e) {
    e = e.lastChild;while (e) {
      var t = e.previousSibling;v(e, !0), e = t;
    }
  }function y(e, t, n) {
    var o;for (o in n) {
      t && null != t[o] || null == n[o] || s(e, o, n[o], n[o] = void 0, R);
    }for (o in t) {
      "children" === o || "innerHTML" === o || o in n && t[o] === ("value" === o || "checked" === o ? e[o] : n[o]) || s(e, o, n[o], n[o] = t[o], R);
    }
  }function g(e, t, n) {
    var o,
        r = F.length;e.prototype && e.prototype.render ? (o = new e(t, n), U.call(o, t, n)) : (o = new U(t, n), o.constructor = e, o.render = w);while (r--) {
      if (F[r].constructor === e) return o.__b = F[r].__b, F.splice(r, 1), o;
    }return o;
  }function w(e, t, n) {
    return this.constructor(e, n);
  }function C(e, t, o, i, l) {
    e.__x || (e.__x = !0, e.__r = t.ref, e.__k = t.key, delete t.ref, delete t.key, void 0 === e.constructor.getDerivedStateFromProps && (!e.base || l ? e.componentWillMount && e.componentWillMount() : e.componentWillReceiveProps && e.componentWillReceiveProps(t, i)), i && i !== e.context && (e.__c || (e.__c = e.context), e.context = i), e.__p || (e.__p = e.props), e.props = t, e.__x = !1, 0 !== o && (1 !== o && !1 === M.syncComponentUpdates && e.base ? r(e) : x(e, 1, l)), n(e.__r, e));
  }function x(e, n, o, r) {
    if (!e.__x) {
      var i,
          l,
          a,
          c = e.props,
          p = e.state,
          s = e.context,
          _ = e.__p || c,
          h = e.__s || p,
          m = e.__c || s,
          b = e.base,
          y = e.__b,
          w = b || y,
          N = e._component,
          U = !1,
          S = m;if (e.constructor.getDerivedStateFromProps && (p = t(t({}, p), e.constructor.getDerivedStateFromProps(c, p)), e.state = p), b && (e.props = _, e.state = h, e.context = m, 2 !== n && e.shouldComponentUpdate && !1 === e.shouldComponentUpdate(c, p, s) ? U = !0 : e.componentWillUpdate && e.componentWillUpdate(c, p, s), e.props = c, e.state = p, e.context = s), e.__p = e.__s = e.__c = e.__b = null, e.__d = !1, !U) {
        i = e.render(c, p, s), e.getChildContext && (s = t(t({}, s), e.getChildContext())), b && e.getSnapshotBeforeUpdate && (S = e.getSnapshotBeforeUpdate(_, h));var L,
            T,
            P = i && i.nodeName;if ("function" == typeof P) {
          var W = u(i);l = N, l && l.constructor === P && W.key == l.__k ? C(l, W, 1, s, !1) : (L = l, e._component = l = g(P, W, s), l.__b = l.__b || y, l.__u = e, C(l, W, 0, s, !1), x(l, 1, o, !0)), T = l.base;
        } else a = w, L = N, L && (a = e._component = null), (w || 1 === n) && (a && (a._component = null), T = d(a, i, s, o || !b, w && w.parentNode, !0));if (w && T !== w && l !== N) {
          var D = w.parentNode;D && T !== D && (D.replaceChild(T, w), L || (w._component = null, v(w, !1)));
        }if (L && k(L), e.base = T, T && !r) {
          var E = e,
              V = e;while (V = V.__u) {
            (E = V).base = T;
          }T._component = E, T._componentConstructor = E.constructor;
        }
      }!b || o ? A.push(e) : U || (e.componentDidUpdate && e.componentDidUpdate(_, h, S), M.afterUpdate && M.afterUpdate(e));while (e.__h.length) {
        e.__h.pop().call(e);
      }H || r || f();
    }
  }function N(e, t, n, o) {
    var r = e && e._component,
        i = r,
        l = e,
        a = r && e._componentConstructor === t.nodeName,
        c = a,
        p = u(t);while (r && !c && (r = r.__u)) {
      c = r.constructor === t.nodeName;
    }return r && c && (!o || r._component) ? (C(r, p, 3, n, o), e = r.base) : (i && !a && (k(i), e = l = null), r = g(t.nodeName, p, n), e && !r.__b && (r.__b = e, l = null), C(r, p, 1, n, o), e = r.base, l && e !== l && (l._component = null, v(l, !1))), e;
  }function k(e) {
    M.beforeUnmount && M.beforeUnmount(e);var t = e.base;e.__x = !0, e.componentWillUnmount && e.componentWillUnmount(), e.base = null;var o = e._component;o ? k(o) : t && (null != t.__preactattr_ && n(t.__preactattr_.ref, null), e.__b = t, p(t), F.push(e), b(t)), n(e.__r, null);
  }function U(e, t) {
    this.__d = !0, this.context = t, this.props = e, this.state = this.state || {}, this.__h = [];
  }function S(e, t, n) {
    return d(n, e, {}, !1, t, !1);
  }function L() {
    return {};
  }var T = function T() {},
      M = {},
      P = [],
      W = [],
      D = "function" == typeof Promise ? Promise.resolve().then.bind(Promise.resolve()) : setTimeout,
      E = /acit|ex(?:s|g|n|p|$)|rph|ows|mnc|ntw|ine[ch]|zoo|^ord/i,
      V = [],
      A = [],
      H = 0,
      R = !1,
      B = !1,
      F = [];t(U.prototype, { setState: function setState(e, n) {
      this.__s || (this.__s = this.state), this.state = t(t({}, this.state), "function" == typeof e ? e(this.state, this.props) : e), n && this.__h.push(n), r(this);
    }, forceUpdate: function forceUpdate(e) {
      e && this.__h.push(e), x(this, 2);
    }, render: function render() {} });var j = { h: e, createElement: e, cloneElement: o, createRef: L, Component: U, render: S, rerender: i, options: M }; true ? module.exports = j : self.preact = j;
}();
//# sourceMappingURL=preact.min.js.map

/***/ }),

/***/ "QlVn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ../node_modules/idb/build/idb.js
var idb = __webpack_require__("iYir");
var idb_default = /*#__PURE__*/__webpack_require__.n(idb);

// CONCATENATED MODULE: ./utils/db.js
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



var db_DB = function () {
  function DB(dbPromise) {
    _classCallCheck(this, DB);

    this.db = dbPromise || Object(idb["openDb"])('entries-store');
  }

  DB.prototype.get = function get(table, key) {
    return this.db.then(function (db) {
      return db.transaction(table).objectStore(table).get(key);
    });
  };

  DB.prototype.set = function set(table, key, val) {
    return this.db.then(function (db) {
      var tx = db.transaction(table, 'readwrite');
      tx.objectStore(table).put(val, key);
      return tx.complete;
    });
  };

  DB.prototype.delete = function _delete(table, key) {
    return this.db.then(function (db) {
      var tx = db.transaction(table, 'readwrite');
      tx.objectStore(table).delete(key);
      return tx.complete;
    });
  };

  DB.prototype.clear = function clear(table) {
    return this.db.then(function (db) {
      var tx = db.transaction(table, 'readwrite');
      tx.objectStore(table).clear();
      return tx.complete;
    });
  };

  DB.prototype.keys = function keys(table) {
    return this.db.then(function (db) {
      var tx = db.transaction(table);
      var keys = [];
      var store = tx.objectStore(table);

      (store.iterateKeyCursor || store.iterateCursor).call(store, function (cursor) {
        if (!cursor) return;
        keys.push(cursor.key);
        cursor.continue();
      });

      return tx.complete.then(function () {
        keys.reverse();
        return keys;
      });
    });
  };

  DB.prototype.getAll = function getAll(table) {
    return this.db.then(function (db) {
      return db.transaction(table).objectStore(table).getAll();
    });
  };

  DB.prototype.getObject = function getObject(table) {
    return new Promise(function ($return, $error) {
      var _this, keys, values;

      _this = this;
      return Promise.resolve(this.keys(table)).then(function ($await_1) {
        try {
          keys = $await_1;
          return Promise.resolve(Promise.all(keys.map(function (key) {
            return _this.get(table, key);
          }))).then(function ($await_2) {
            try {
              values = $await_2;

              return $return(values.reduce(function (current, entry, index) {
                current[keys[index]] = entry;
                return current;
              }, {}));
            } catch ($boundEx) {
              return $error($boundEx);
            }
          }, $error);
        } catch ($boundEx) {
          return $error($boundEx);
        }
      }, $error);
    }.bind(this));
  };

  return DB;
}();
// CONCATENATED MODULE: ./store/actions.js
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return actions_actions; });
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var actions_actions = function actions(store) {
  return {
    boot: function boot(state, dbPromise) {
      return new Promise(function ($return, $error) {
        var db, savedSettings;

        db = new db_DB(dbPromise);
        return Promise.resolve(db.getObject('settings')).then(function ($await_1) {
          try {
            savedSettings = $await_1;
            return $return({ db: db, settings: _extends({}, state.settings, savedSettings) });
          } catch ($boundEx) {
            return $error($boundEx);
          }
        }, $error);
      });
    },

    updateSetting: function updateSetting(state, _ref) {
      var _ref$key = _ref.key,
          key = _ref$key === undefined ? '' : _ref$key,
          _ref$value = _ref.value,
          value = _ref$value === undefined ? '' : _ref$value;

      if (!state.db) return;

      var settings = _extends({}, state.settings);
      settings[key] = value;

      state.db.set('settings', key, value);

      return { settings: settings };
    }
  };
};

/***/ }),

/***/ "b1q8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getTrackingQuestions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return isAnswerValid; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getPresetQuestions; });
var getTrackingQuestions = function getTrackingQuestions(db) {
  return new Promise(function ($return, $error) {
    var trackingQuestions;
    return Promise.resolve(db.getAll('trackingQuestions')).then(function ($await_1) {
      try {
        trackingQuestions = $await_1;
        return $return(trackingQuestions.sort(function (a, b) {
          return a.createdAt - b.createdAt;
        }));
      } catch ($boundEx) {
        return $error($boundEx);
      }
    }, $error);
  });
};

var isAnswerValid = function isAnswerValid() {
  var answer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  if (Array.isArray(answer.value)) {
    return !!answer.value.filter(Boolean).length;
  }

  return answer.value !== null && answer.value !== undefined;
};

var getPresetQuestions = function getPresetQuestions() {
  return {
    sleep: [{
      id: '',
      groupId: '',
      title: 'How did you sleep?',
      priority: 0,
      type: 'number',
      createdAt: Date.now(),
      expiryDate: null,
      notes: true,
      status: 'live',
      settings: { type: 'star', calculation: 'average', default: null }
    }, {
      id: '',
      groupId: '',
      title: 'How many hours did you sleep for?',
      priority: 0,
      type: 'number',
      createdAt: Date.now(),
      expiryDate: null,
      notes: false,
      status: 'live',
      settings: { type: 'number', calculation: 'average', default: null }
    }],
    medicine: [{
      id: '',
      groupId: '',
      title: 'Have you taken your antibiotics?',
      priority: 0,
      type: 'options',
      createdAt: Date.now(),
      expiryDate: null,
      notes: true,
      status: 'live',
      settings: {
        type: 'checkbox',
        calculation: '',
        default: [],
        options: ['9am', '1pm', '5pm']
      }
    }],
    panic: [{
      id: '',
      groupId: '',
      title: 'Did you have a panic attack today?',
      priority: 0,
      type: 'options',
      createdAt: Date.now(),
      expiryDate: null,
      notes: 'What happened?',
      status: 'live',
      settings: { type: 'lightswitch', calculation: 'count', default: [] }
    }],
    musical: [{
      id: '',
      groupId: '',
      title: 'How long did you practice your guitar for? (mins)',
      priority: 0,
      type: 'number',
      createdAt: Date.now(),
      expiryDate: null,
      notes: 'What did you work on?',
      status: 'live',
      settings: { type: 'number', calculation: 'total', default: [] }
    }],
    running: [{
      id: '',
      groupId: '',
      title: 'How far did you run today? (km)',
      priority: 0,
      type: 'number',
      createdAt: Date.now(),
      expiryDate: null,
      notes: false,
      status: 'live',
      settings: { type: 'number', calculation: 'total', default: null }
    }, {
      id: '',
      groupId: '',
      title: 'How long did you run for? (mins)',
      priority: 0,
      type: 'number',
      createdAt: Date.now(),
      expiryDate: null,
      notes: true,
      status: 'live',
      settings: { type: 'number', calculation: 'total', default: null }
    }],
    asthma: [{
      id: '',
      groupId: '',
      title: 'How many inhaler puffs did you require?',
      priority: 0,
      type: 'number',
      createdAt: Date.now(),
      expiryDate: null,
      notes: false,
      status: 'live',
      settings: { type: 'plus', calculation: 'average', default: null }
    }, {
      id: '',
      groupId: '',
      title: 'Did you have an asthma attack today?',
      priority: 0,
      type: 'options',
      createdAt: Date.now(),
      expiryDate: null,
      notes: 'What happened?',
      status: 'live',
      settings: { type: 'lightswitch', calculation: 'count', default: [] }
    }],
    mood: [{
      id: '',
      groupId: '',
      title: 'Rate your mood today',
      priority: 0,
      type: 'number',
      createdAt: Date.now(),
      expiryDate: null,
      notes: true,
      status: 'live',
      settings: {
        type: 'range',
        min: 1,
        max: 10,
        calculation: 'average',
        default: null
      }
    }],
    discomfort: [{
      id: '',
      groupId: '',
      title: 'Rate your level of pain/discomfort today',
      priority: 0,
      type: 'number',
      createdAt: Date.now(),
      expiryDate: null,
      notes: true,
      status: 'live',
      settings: {
        type: 'range',
        min: 1,
        max: 10,
        calculation: 'average',
        default: null
      }
    }],
    workout: [{
      id: '',
      groupId: '',
      title: 'How long did you work out for? (mins)',
      priority: 0,
      type: 'number',
      createdAt: Date.now(),
      expiryDate: null,
      notes: false,
      status: 'live',
      settings: { type: 'number', calculation: 'average', default: null }
    }, {
      id: '',
      groupId: '',
      title: 'What did you work on?',
      priority: 0,
      type: 'options',
      createdAt: Date.now(),
      expiryDate: null,
      notes: true,
      status: 'live',
      settings: {
        type: 'select',
        calculation: '',
        default: [],
        options: ['Endurance', 'Strength', 'Balance', 'Flexibility']
      }
    }],
    number: [{
      id: '',
      groupId: '',
      title: 'Custom question',
      priority: 0,
      type: 'number',
      createdAt: Date.now(),
      expiryDate: null,
      notes: true,
      status: 'live',
      settings: { type: 'number', calculation: 'total', default: [] }
    }],
    choices: [{
      id: '',
      groupId: '',
      title: 'Custom question',
      priority: 0,
      type: 'options',
      createdAt: Date.now(),
      expiryDate: null,
      notes: true,
      status: 'live',
      settings: {
        type: 'select',
        calculation: '',
        default: [],
        options: ['Custom option']
      }
    }],
    tickbox: [{
      id: '',
      groupId: '',
      title: 'Custom question',
      priority: 0,
      type: 'options',
      createdAt: Date.now(),
      expiryDate: null,
      notes: true,
      status: 'live',
      settings: { type: 'lightswitch', calculation: 'count', default: [] }
    }]
  };
};

/***/ }),

/***/ "dAjQ":
/***/ (function(module, exports) {

/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */
var byteToHex = [];
for (var i = 0; i < 256; ++i) {
  byteToHex[i] = (i + 0x100).toString(16).substr(1);
}

function bytesToUuid(buf, offset) {
  var i = offset || 0;
  var bth = byteToHex;
  // join used to fix memory issue caused by concatenation: https://bugs.chromium.org/p/v8/issues/detail?id=3175#c4
  return [bth[buf[i++]], bth[buf[i++]], bth[buf[i++]], bth[buf[i++]], '-', bth[buf[i++]], bth[buf[i++]], '-', bth[buf[i++]], bth[buf[i++]], '-', bth[buf[i++]], bth[buf[i++]], '-', bth[buf[i++]], bth[buf[i++]], bth[buf[i++]], bth[buf[i++]], bth[buf[i++]], bth[buf[i++]]].join('');
}

module.exports = bytesToUuid;

/***/ }),

/***/ "db16":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_preact_router_match__ = __webpack_require__("sw5u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_preact_router_match___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_preact_router_match__);




var _ref2 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
  'svg',
  { width: '8', height: '14', xmlns: 'http://www.w3.org/2000/svg' },
  Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    'title',
    null,
    'Previous'
  ),
  Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('path', {
    d: 'M2.4 7l5.3-5.3c.4-.4.4-1 0-1.4-.4-.4-1-.4-1.4 0l-6 6c-.4.4-.4 1 0 1.4l6 6c.2.2.5.3.7.3.2 0 .5-.1.7-.3.4-.4.4-1 0-1.4L2.4 7z',
    fill: 'currentColor',
    'fill-rule': 'nonzero'
  })
);

var _ref3 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
  'svg',
  { width: '8', height: '14', xmlns: 'http://www.w3.org/2000/svg' },
  Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    'title',
    null,
    'Next'
  ),
  Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('path', {
    d: 'M7.7 6.3l-6-6C1.3-.1.7-.1.3.3c-.4.4-.4 1 0 1.4L5.6 7 .3 12.3c-.4.4-.4 1 0 1.4.2.2.4.3.7.3.3 0 .5-.1.7-.3l6-6c.4-.4.4-1 0-1.4z',
    fill: 'currentColor',
    'fill-rule': 'nonzero'
  })
);

var Traverse = function Traverse(_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === undefined ? '' : _ref$title,
      _ref$lastLink = _ref.lastLink,
      lastLink = _ref$lastLink === undefined ? '' : _ref$lastLink,
      _ref$nextLink = _ref.nextLink,
      nextLink = _ref$nextLink === undefined ? '' : _ref$nextLink,
      _ref$actions = _ref.actions,
      actions = _ref$actions === undefined ? null : _ref$actions,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className;

  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    'header',
    { 'class': 'traverse ' + className },
    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      'h2',
      null,
      title
    ),
    actions,
    lastLink || lastLink === false ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      __WEBPACK_IMPORTED_MODULE_1_preact_router_match__["Link"],
      {
        'class': 'traverse__arrow',
        disabled: lastLink === false,
        href: lastLink
      },
      _ref2
    ) : null,
    nextLink || nextLink === false ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      __WEBPACK_IMPORTED_MODULE_1_preact_router_match__["Link"],
      {
        'class': 'traverse__arrow',
        disabled: nextLink === false,
        href: nextLink
      },
      _ref3
    ) : null
  );
};

/* harmony default export */ __webpack_exports__["a"] = (Traverse);

/***/ }),

/***/ "f+DB":
/***/ (function(module, exports) {

// Unique ID creation requires a high quality random # generator.  In the
// browser this is a little complicated due to unknown quality of Math.random()
// and inconsistent support for the `crypto` API.  We do the best we can via
// feature-detection

// getRandomValues needs to be invoked in a context where "this" is a Crypto
// implementation. Also, find the complete implementation of crypto on IE11.
var getRandomValues = typeof crypto != 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto != 'undefined' && typeof window.msCrypto.getRandomValues == 'function' && msCrypto.getRandomValues.bind(msCrypto);

if (getRandomValues) {
  // WHATWG crypto RNG - http://wiki.whatwg.org/wiki/Crypto
  var rnds8 = new Uint8Array(16); // eslint-disable-line no-undef

  module.exports = function whatwgRNG() {
    getRandomValues(rnds8);
    return rnds8;
  };
} else {
  // Math.random()-based (RNG)
  //
  // If all else fails, use Math.random().  It's fast, but is of unspecified
  // quality.
  var rnds = new Array(16);

  module.exports = function mathRNG() {
    for (var i = 0, r; i < 16; i++) {
      if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
      rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
    }

    return rnds;
  };
}

/***/ }),

/***/ "hYHi":
/***/ (function(module, exports, __webpack_require__) {

var rng = __webpack_require__("f+DB");
var bytesToUuid = __webpack_require__("dAjQ");

function v4(options, buf, offset) {
  var i = buf && offset || 0;

  if (typeof options == 'string') {
    buf = options === 'binary' ? new Array(16) : null;
    options = null;
  }
  options = options || {};

  var rnds = options.random || (options.rng || rng)();

  // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
  rnds[6] = rnds[6] & 0x0f | 0x40;
  rnds[8] = rnds[8] & 0x3f | 0x80;

  // Copy bytes to buffer, if provided
  if (buf) {
    for (var ii = 0; ii < 16; ++ii) {
      buf[i + ii] = rnds[ii];
    }
  }

  return buf || bytesToUuid(rnds);
}

module.exports = v4;

/***/ }),

/***/ "iYir":
/***/ (function(module, exports, __webpack_require__) {

(function (global, factory) {
   true ? factory(exports) : typeof define === 'function' && define.amd ? define(['exports'], factory) : (global = global || self, factory(global.idb = {}));
})(this, function (exports) {
  'use strict';

  function toArray(arr) {
    return Array.prototype.slice.call(arr);
  }

  function promisifyRequest(request) {
    return new Promise(function (resolve, reject) {
      request.onsuccess = function () {
        resolve(request.result);
      };

      request.onerror = function () {
        reject(request.error);
      };
    });
  }

  function promisifyRequestCall(obj, method, args) {
    var request;
    var p = new Promise(function (resolve, reject) {
      request = obj[method].apply(obj, args);
      promisifyRequest(request).then(resolve, reject);
    });

    p.request = request;
    return p;
  }

  function promisifyCursorRequestCall(obj, method, args) {
    var p = promisifyRequestCall(obj, method, args);
    return p.then(function (value) {
      if (!value) return;
      return new Cursor(value, p.request);
    });
  }

  function proxyProperties(ProxyClass, targetProp, properties) {
    properties.forEach(function (prop) {
      Object.defineProperty(ProxyClass.prototype, prop, {
        get: function get() {
          return this[targetProp][prop];
        },
        set: function set(val) {
          this[targetProp][prop] = val;
        }
      });
    });
  }

  function proxyRequestMethods(ProxyClass, targetProp, Constructor, properties) {
    properties.forEach(function (prop) {
      if (!(prop in Constructor.prototype)) return;
      ProxyClass.prototype[prop] = function () {
        return promisifyRequestCall(this[targetProp], prop, arguments);
      };
    });
  }

  function proxyMethods(ProxyClass, targetProp, Constructor, properties) {
    properties.forEach(function (prop) {
      if (!(prop in Constructor.prototype)) return;
      ProxyClass.prototype[prop] = function () {
        return this[targetProp][prop].apply(this[targetProp], arguments);
      };
    });
  }

  function proxyCursorRequestMethods(ProxyClass, targetProp, Constructor, properties) {
    properties.forEach(function (prop) {
      if (!(prop in Constructor.prototype)) return;
      ProxyClass.prototype[prop] = function () {
        return promisifyCursorRequestCall(this[targetProp], prop, arguments);
      };
    });
  }

  function Index(index) {
    this._index = index;
  }

  proxyProperties(Index, '_index', ['name', 'keyPath', 'multiEntry', 'unique']);

  proxyRequestMethods(Index, '_index', IDBIndex, ['get', 'getKey', 'getAll', 'getAllKeys', 'count']);

  proxyCursorRequestMethods(Index, '_index', IDBIndex, ['openCursor', 'openKeyCursor']);

  function Cursor(cursor, request) {
    this._cursor = cursor;
    this._request = request;
  }

  proxyProperties(Cursor, '_cursor', ['direction', 'key', 'primaryKey', 'value']);

  proxyRequestMethods(Cursor, '_cursor', IDBCursor, ['update', 'delete']);

  // proxy 'next' methods
  ['advance', 'continue', 'continuePrimaryKey'].forEach(function (methodName) {
    if (!(methodName in IDBCursor.prototype)) return;
    Cursor.prototype[methodName] = function () {
      var cursor = this;
      var args = arguments;
      return Promise.resolve().then(function () {
        cursor._cursor[methodName].apply(cursor._cursor, args);
        return promisifyRequest(cursor._request).then(function (value) {
          if (!value) return;
          return new Cursor(value, cursor._request);
        });
      });
    };
  });

  function ObjectStore(store) {
    this._store = store;
  }

  ObjectStore.prototype.createIndex = function () {
    return new Index(this._store.createIndex.apply(this._store, arguments));
  };

  ObjectStore.prototype.index = function () {
    return new Index(this._store.index.apply(this._store, arguments));
  };

  proxyProperties(ObjectStore, '_store', ['name', 'keyPath', 'indexNames', 'autoIncrement']);

  proxyRequestMethods(ObjectStore, '_store', IDBObjectStore, ['put', 'add', 'delete', 'clear', 'get', 'getAll', 'getKey', 'getAllKeys', 'count']);

  proxyCursorRequestMethods(ObjectStore, '_store', IDBObjectStore, ['openCursor', 'openKeyCursor']);

  proxyMethods(ObjectStore, '_store', IDBObjectStore, ['deleteIndex']);

  function Transaction(idbTransaction) {
    this._tx = idbTransaction;
    this.complete = new Promise(function (resolve, reject) {
      idbTransaction.oncomplete = function () {
        resolve();
      };
      idbTransaction.onerror = function () {
        reject(idbTransaction.error);
      };
      idbTransaction.onabort = function () {
        reject(idbTransaction.error);
      };
    });
  }

  Transaction.prototype.objectStore = function () {
    return new ObjectStore(this._tx.objectStore.apply(this._tx, arguments));
  };

  proxyProperties(Transaction, '_tx', ['objectStoreNames', 'mode']);

  proxyMethods(Transaction, '_tx', IDBTransaction, ['abort']);

  function UpgradeDB(db, oldVersion, transaction) {
    this._db = db;
    this.oldVersion = oldVersion;
    this.transaction = new Transaction(transaction);
  }

  UpgradeDB.prototype.createObjectStore = function () {
    return new ObjectStore(this._db.createObjectStore.apply(this._db, arguments));
  };

  proxyProperties(UpgradeDB, '_db', ['name', 'version', 'objectStoreNames']);

  proxyMethods(UpgradeDB, '_db', IDBDatabase, ['deleteObjectStore', 'close']);

  function DB(db) {
    this._db = db;
  }

  DB.prototype.transaction = function () {
    return new Transaction(this._db.transaction.apply(this._db, arguments));
  };

  proxyProperties(DB, '_db', ['name', 'version', 'objectStoreNames']);

  proxyMethods(DB, '_db', IDBDatabase, ['close']);

  // Add cursor iterators
  // TODO: remove this once browsers do the right thing with promises
  ['openCursor', 'openKeyCursor'].forEach(function (funcName) {
    [ObjectStore, Index].forEach(function (Constructor) {
      // Don't create iterateKeyCursor if openKeyCursor doesn't exist.
      if (!(funcName in Constructor.prototype)) return;

      Constructor.prototype[funcName.replace('open', 'iterate')] = function () {
        var args = toArray(arguments);
        var callback = args[args.length - 1];
        var nativeObject = this._store || this._index;
        var request = nativeObject[funcName].apply(nativeObject, args.slice(0, -1));
        request.onsuccess = function () {
          callback(request.result);
        };
      };
    });
  });

  // polyfill getAll
  [Index, ObjectStore].forEach(function (Constructor) {
    if (Constructor.prototype.getAll) return;
    Constructor.prototype.getAll = function (query, count) {
      var instance = this;
      var items = [];

      return new Promise(function (resolve) {
        instance.iterateCursor(query, function (cursor) {
          if (!cursor) {
            resolve(items);
            return;
          }
          items.push(cursor.value);

          if (count !== undefined && items.length == count) {
            resolve(items);
            return;
          }
          cursor.continue();
        });
      });
    };
  });

  function openDb(name, version, upgradeCallback) {
    var p = promisifyRequestCall(indexedDB, 'open', [name, version]);
    var request = p.request;

    if (request) {
      request.onupgradeneeded = function (event) {
        if (upgradeCallback) {
          upgradeCallback(new UpgradeDB(request.result, event.oldVersion, request.transaction));
        }
      };
    }

    return p.then(function (db) {
      return new DB(db);
    });
  }

  function deleteDb(name) {
    return promisifyRequestCall(indexedDB, 'deleteDatabase', [name]);
  }

  exports.openDb = openDb;
  exports.deleteDb = deleteDb;

  Object.defineProperty(exports, '__esModule', { value: true });
});

/***/ }),

/***/ "o6ac":
/***/ (function(module, exports, __webpack_require__) {

var t = __webpack_require__("KM04");function n(t, n) {
  for (var r in n) {
    t[r] = n[r];
  }return t;
}function r(t) {
  this.getChildContext = function () {
    return { store: t.store };
  };
}r.prototype.render = function (t) {
  return t.children && t.children[0] || t.children;
}, exports.connect = function (r, e) {
  var o;return "function" != typeof r && ("string" == typeof (o = r || {}) && (o = o.split(/\s*,\s*/)), r = function r(t) {
    for (var n = {}, r = 0; r < o.length; r++) {
      n[o[r]] = t[o[r]];
    }return n;
  }), function (o) {
    function i(i, u) {
      var c = this,
          f = u.store,
          s = r(f ? f.getState() : {}, i),
          a = e ? function (t, n) {
        "function" == typeof t && (t = t(n));var r = {};for (var e in t) {
          r[e] = n.action(t[e]);
        }return r;
      }(e, f) : { store: f },
          p = function p() {
        var t = r(f ? f.getState() : {}, i);for (var n in t) {
          if (t[n] !== s[n]) return s = t, c.setState({});
        }for (var e in s) {
          if (!(e in t)) return s = t, c.setState({});
        }
      };this.componentWillReceiveProps = function (t) {
        i = t, p();
      }, this.componentDidMount = function () {
        f.subscribe(p);
      }, this.componentWillUnmount = function () {
        f.unsubscribe(p);
      }, this.render = function (r) {
        return t.h(o, n(n(n({}, a), r), s));
      };
    }return (i.prototype = new t.Component()).constructor = i;
  };
}, exports.Provider = r;
//# sourceMappingURL=preact.js.map

/***/ }),

/***/ "pwNi":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _preact = __webpack_require__("KM04");

if (false) {
	require('preact/devtools');
} else if (true && 'serviceWorker' in navigator && location.protocol === 'https:') {
	navigator.serviceWorker.register(__webpack_require__.p + 'sw.js');
}

var interopDefault = function interopDefault(m) {
	return m && m.default ? m.default : m;
};

var app = interopDefault(__webpack_require__("JkW7"));

if (typeof app === 'function') {
	var root = document.body.firstElementChild;

	var init = function init() {
		var app = interopDefault(__webpack_require__("JkW7"));
		root = (0, _preact.render)((0, _preact.h)(app), document.body, root);
	};

	if (false) module.hot.accept('preact-cli-entrypoint', init);

	init();
}

/***/ }),

/***/ "rq4c":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "sw5u":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.Link = exports.Match = undefined;

var _extends = Object.assign || function (target) {
	for (var i = 1; i < arguments.length; i++) {
		var source = arguments[i];for (var key in source) {
			if (Object.prototype.hasOwnProperty.call(source, key)) {
				target[key] = source[key];
			}
		}
	}return target;
};

var _preact = __webpack_require__("KM04");

var _preactRouter = __webpack_require__("/QC5");

function _objectWithoutProperties(obj, keys) {
	var target = {};for (var i in obj) {
		if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
	}return target;
}

function _classCallCheck(instance, Constructor) {
	if (!(instance instanceof Constructor)) {
		throw new TypeError("Cannot call a class as a function");
	}
}

function _possibleConstructorReturn(self, call) {
	if (!self) {
		throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	}return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
	if (typeof superClass !== "function" && superClass !== null) {
		throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var Match = exports.Match = function (_Component) {
	_inherits(Match, _Component);

	function Match() {
		var _temp, _this, _ret;

		_classCallCheck(this, Match);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.update = function (url) {
			_this.nextUrl = url;
			_this.setState({});
		}, _temp), _possibleConstructorReturn(_this, _ret);
	}

	Match.prototype.componentDidMount = function componentDidMount() {
		_preactRouter.subscribers.push(this.update);
	};

	Match.prototype.componentWillUnmount = function componentWillUnmount() {
		_preactRouter.subscribers.splice(_preactRouter.subscribers.indexOf(this.update) >>> 0, 1);
	};

	Match.prototype.render = function render(props) {
		var url = this.nextUrl || (0, _preactRouter.getCurrentUrl)(),
		    path = url.replace(/\?.+$/, '');
		this.nextUrl = null;
		return props.children[0] && props.children[0]({
			url: url,
			path: path,
			matches: path === props.path
		});
	};

	return Match;
}(_preact.Component);

var Link = function Link(_ref) {
	var activeClassName = _ref.activeClassName,
	    path = _ref.path,
	    props = _objectWithoutProperties(_ref, ['activeClassName', 'path']);

	return (0, _preact.h)(Match, { path: path || props.href }, function (_ref2) {
		var matches = _ref2.matches;
		return (0, _preact.h)(_preactRouter.Link, _extends({}, props, { 'class': [props.class || props.className, matches && activeClassName].filter(Boolean).join(' ') }));
	});
};

exports.Link = Link;
exports.default = Match;

Match.Link = Link;

/***/ }),

/***/ "wGNj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getDefaultTheme; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return prefersAnimation; });
var getDefaultTheme = function getDefaultTheme() {
  var settings = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var theme = settings.theme || null;

  if (theme !== null) {
    return theme;
  }

  if (window.matchMedia('(prefers-color-scheme: dark)').matches) {
    return 'dark';
  }

  return '';
};

var prefersAnimation = function prefersAnimation() {
  var settings = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var preference = settings.animation || null;

  if (preference !== null) {
    return preference;
  }

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    return 'off';
  }

  return '';
};

/***/ })

/******/ });


// WEBPACK FOOTER //
// bundle.b4d7a.js